import { apiRequest } from './api';

// Authentication service
export const authService = {
  // Sign in user
  signin: async (credentials) => {
    return await apiRequest('/signin', {
      method: 'POST',
      body: credentials,
    });
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const session = localStorage.getItem('session');
    return !!session;
  },

  // Get current user session
  getCurrentSession: () => {
    const session = localStorage.getItem('session');
    return session ? JSON.parse(session) : null;
  },

  // Logout user
  logout: () => {
    localStorage.removeItem('session');
    localStorage.removeItem('activeComponent');
  },

  // Store session
  storeSession: (sessionData) => {
    localStorage.setItem('session', JSON.stringify(sessionData));
    localStorage.setItem('activeComponent', 'ViewGymMembers');
  }
};
